var _excluded = ["checked", "children", "className", "color", "disabled", "hint", "indeterminate", "size", "onClick", "required", "rules", "validationState", "value", "wrap"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef, useContext, useEffect, useRef, useState } from "react";
import { AFormContext } from "../AForm";
import AHint from "../AHint";
import { isStockColor, isValidColor } from "../../utils/helpers";
import { useCombinedRefs } from "../../utils/hooks";
import "./ACheckbox.scss";
var Icons = {
  checked: "M 2.9999998,0 C 1.3380015,0 0,1.3380016 0,3 v 9 c 0,1.661998 1.3380015,3 2.9999998,3 H 12 c 1.661997,0 3,-1.338002 3,-3 V 3 C 15,1.3380016 13.661997,0 12,0 Z M 10.344726,4.3447266 11.405273,5.4052734 6.3749998,10.435546 3.5947265,7.6552732 4.6552731,6.5947266 6.3749998,8.3144535 Z",
  unchecked: "M 2.9093777,0 C 1.3101651,0 0,1.3101651 0,2.9093777 v 8.7281333 c 0,1.599213 1.3101651,2.909377 2.9093777,2.909377 h 8.7281333 c 1.599213,0 2.909377,-1.310164 2.909377,-2.909377 V 2.9093777 C 14.546888,1.3101651 13.236724,0 11.637511,0 Z m 0,1.4546888 h 8.7281333 c 0.818477,0 1.454689,0.636211 1.454689,1.4546889 v 8.7281333 c 0,0.818477 -0.636212,1.454689 -1.454689,1.454689 H 2.9093777 c -0.8184779,0 -1.4546889,-0.636212 -1.4546889,-1.454689 V 2.9093777 c 0,-0.8184779 0.636211,-1.4546889 1.4546889,-1.4546889 z",
  indeterminate: "M 3,0 C 1.3380017,0 0,1.3380017 0,3 v 9 c 0,1.661999 1.3380017,3 3,3 h 9 c 1.661999,0 3,-1.338001 3,-3 V 3 C 15,1.3380017 13.661999,0 12,0 Z m 0.75,6.75 h 7.5 v 1.5 h -7.5 z"
};
var checkboxCounter = 0;
var ACheckbox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    children = _ref.children,
    propsClassName = _ref.className,
    color = _ref.color,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    hint = _ref.hint,
    _ref$indeterminate = _ref.indeterminate,
    indeterminate = _ref$indeterminate === void 0 ? false : _ref$indeterminate,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "default" : _ref$size,
    _onClick = _ref.onClick,
    required = _ref.required,
    rules = _ref.rules,
    validationState = _ref.validationState,
    value = _ref.value,
    wrap = _ref.wrap,
    rest = _objectWithoutProperties(_ref, _excluded);
  var checkboxRef = useRef(null);
  var combinedRef = useCombinedRefs(ref, checkboxRef);
  var _useState = useState(checkboxCounter++),
    _useState2 = _slicedToArray(_useState, 1),
    checkboxId = _useState2[0];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(validationState),
    _useState6 = _slicedToArray(_useState5, 2),
    workingValidationState = _useState6[0],
    setWorkingValidationState = _useState6[1];
  var _useContext = useContext(AFormContext),
    register = _useContext.register,
    unregister = _useContext.unregister;
  useEffect(function () {
    setWorkingValidationState(validationState);
  }, [validationState]);
  useEffect(function () {
    if (register) {
      register("a-checkbox_".concat(checkboxId), {
        reset: reset,
        validate: validate
      });
    }
  }, [validationState, checked, value, rules]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    if (unregister) {
      return function () {
        return unregister("a-checkbox_".concat(checkboxId));
      };
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var validate = function validate() {
    var testValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : checked;
    if (rules || required) {
      var workingRules = [];
      if (rules) {
        workingRules = _toConsumableArray(rules);
      }
      if (required) {
        workingRules = [{
          test: function test(v) {
            return !!v || "Required";
          },
          level: "danger"
        }].concat(_toConsumableArray(workingRules));
      }
      setWorkingValidationState("default");
      setError(null);
      for (var i = 0; i < workingRules.length; i++) {
        var _error = workingRules[i].test(testValue);
        if (_error !== true) {
          setError(_error);
          setWorkingValidationState(workingRules[i].level || "danger");
          return {
            message: _error,
            level: workingRules[i].level || "danger"
          };
        }
      }
    }
  };
  var reset = function reset() {
    setWorkingValidationState(validationState);
    setError("");
  };
  var className = "a-checkbox";
  if (["danger", "warning"].includes(workingValidationState)) {
    className += " a-checkbox--".concat(workingValidationState);
  }
  if (disabled) {
    className += " a-checkbox--disabled";
  }
  if (!disabled) {
    className += " a-checkbox--enabled";
  }
  if (checked || indeterminate) {
    className += " a-checkbox--selected";
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  var boxProps = {
    "aria-hidden": "true",
    className: "a-checkbox__box".concat(size && (size === "medium" || size === "small") ? " a-".concat(size, "-box") : "")
  };
  if (!disabled && !["danger", "warning"].includes(workingValidationState)) {
    if (isStockColor(color)) {
      boxProps.className += " ".concat(color, "--text");
    } else {
      boxProps.style = {
        fill: color,
        color: color
      };
    }
  }
  var currentPath = Icons.unchecked;
  if (indeterminate) {
    currentPath = Icons.indeterminate;
  } else if (checked) {
    currentPath = Icons.checked;
  }
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    ref: combinedRef,
    className: className
  }), /*#__PURE__*/React.createElement("label", {
    className: "a-checkbox__wrap"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    className: "a-checkbox__input",
    value: value,
    "aria-checked": indeterminate ? "mixed" : checked,
    checked: checked,
    "aria-disabled": disabled,
    disabled: disabled,
    onChange: function onChange() {},
    onClick: function onClick(e) {
      validate(e.target.checked);
      _onClick && _onClick(e);
    },
    ref: function ref(el) {
      return el && ((el.indeterminate = indeterminate) || (el.checked = checked));
    }
  }), /*#__PURE__*/React.createElement("span", boxProps, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, /*#__PURE__*/React.createElement("path", {
    d: currentPath
  }))), /*#__PURE__*/React.createElement("span", {
    className: "a-checkbox__label".concat(wrap ? " a-checkbox__label--wrap" : "")
  }, children)), (error || hint) && /*#__PURE__*/React.createElement(AHint, {
    validationState: workingValidationState
  }, error || hint));
});
ACheckbox.propTypes = {
  /**
   * Toggles the `checked` state.
   */
  checked: PropTypes.bool,
  /**
   * Specify the checkbox color. Accepts any stock color or CSS color value. The default value is cisco-blue base.
   */
  color: isValidColor,
  /**
   * Toggles the `disabled` state.
   */
  disabled: PropTypes.bool,
  /**
   * Sets the hint content.
   */
  hint: PropTypes.node,
  /**
   * Toggles the `indeterminate` state.
   */
  indeterminate: PropTypes.bool,
  /**
   * A callback for handling the click event.
   */
  onClick: PropTypes.func,
  /**
   * Toggles a default rule for required values.
   */
  required: PropTypes.bool,
  /**
   * Sets validation rules for the component.
   */
  rules: PropTypes.arrayOf(PropTypes.shape({
    test: PropTypes.func,
    level: PropTypes.string
  })),
  /**
   * Applies a validation state.
   */
  validationState: PropTypes.oneOf(["default", "warning", "danger"]),
  /**
   * The input's value.
   */
  value: PropTypes.string,
  /**
   * Toggles wrapping of long text in the label.
   */
  wrap: PropTypes.bool,
  /**
   * Size options ["default","medium","small"]
   * Default size is 15px, Magnetic Medium = 20px, Magnetic Small = 16px
   */
  size: PropTypes.oneOf(["default", "small", "medium"])
};
ACheckbox.displayName = "ACheckbox";
export default ACheckbox;